import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationChromeNotificationsEmptyState(props) {
  return (
    <svg
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={15.84}
        cy={15.84}
        r={11.04}
        stroke="currentColor"
        strokeWidth={9.6}
      />
      <path
        d="M59.52 15.84c0 5.963-5.022 11.04-11.52 11.04-6.498 0-11.52-5.077-11.52-11.04C36.48 9.877 41.502 4.8 48 4.8c6.498 0 11.52 5.077 11.52 11.04z"
        stroke="currentColor"
        strokeWidth={9.6}
      />
      <circle cx={80.16} cy={15.84} r={15.84} fill="currentColor" />
      <path
        d="M26.88 48c0 6.498-5.077 11.52-11.04 11.52C9.877 59.52 4.8 54.498 4.8 48c0-6.498 5.077-11.52 11.04-11.52 5.963 0 11.04 5.022 11.04 11.52z"
        stroke="currentColor"
        strokeWidth={9.6}
      />
      <circle
        cx={48}
        cy={48}
        r={11.52}
        stroke="currentColor"
        strokeWidth={9.6}
      />
      <path
        d="M91.2 48c0 6.498-5.077 11.52-11.04 11.52-5.963 0-11.04-5.022-11.04-11.52 0-6.498 5.077-11.52 11.04-11.52 5.963 0 11.04 5.022 11.04 11.52z"
        stroke="currentColor"
        strokeWidth={9.6}
      />
      <circle
        cx={15.84}
        cy={80.16}
        r={11.04}
        stroke="currentColor"
        strokeWidth={9.6}
      />
      <path
        d="M59.52 80.16c0 5.963-5.022 11.04-11.52 11.04-6.498 0-11.52-5.077-11.52-11.04 0-5.963 5.022-11.04 11.52-11.04 6.498 0 11.52 5.077 11.52 11.04z"
        stroke="currentColor"
        strokeWidth={9.6}
      />
      <circle
        cx={80.16}
        cy={80.16}
        r={11.04}
        stroke="currentColor"
        strokeWidth={9.6}
      />
    </svg>
  );
}

export default IllustrationChromeNotificationsEmptyState;
